import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useCallback } from 'react';

export const LedgerList = ({ pymtObj }) => {
  const augRowsReq = useCallback(
    (rowsReq) => {
      rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('id', pymtObj.ledgerIds));
    },
    [pymtObj.ledgerIds],
  );

  if (!pymtObj.ledgerIds) {
    return null;
  }

  return <EntityList entity={`${pymtObj.domain}_LEDGER`} augRowsReq={augRowsReq} />;
};
